import api from './api';

const kpisApi = {
  // Fonctions référentiel
  getFonctions: () => api.get('/kpis/fonctions'),
  createFonction: (data) => api.post('/kpis/fonctions', data),
  updateFonction: (id, data) => api.put(`/kpis/fonctions/${id}`, data),
  deleteFonction: (id) => api.delete(`/kpis/fonctions/${id}`),

  // Definitions
  getDefinitions: (params) => api.get('/kpis/definitions', { params }),
  createDefinition: (data) => api.post('/kpis/definitions', data),
  updateDefinition: (id, data) => api.put(`/kpis/definitions/${id}`, data),
  deleteDefinition: (id) => api.delete(`/kpis/definitions/${id}`),

  // Ma journée
  getMyDay: (date, fonction) => api.get('/kpis/my-day', { params: { date, fonction } }),
  saveEntry: (data) => api.put('/kpis/entry', data),

  // Suivi équipe
  getTeam: (params) => api.get('/kpis/team', { params }),

  // Team viewers (qui a accès à l'onglet Suivi équipe + scope services)
  getMyTeamAccess: () => api.get('/kpis/team-viewers/me'),
  getTeamViewers: () => api.get('/kpis/team-viewers'),
  addTeamViewer: (data) => api.post('/kpis/team-viewers', data),
  updateTeamViewer: (id, data) => api.put(`/kpis/team-viewers/${id}`, data),
  deleteTeamViewer: (id) => api.delete(`/kpis/team-viewers/${id}`),
};

export default kpisApi;
